import { getContentByRef } from './get-content-by-ref.js';

function getSizeGuideDocument(sizeGuideDocumentRef, pageModel) {
    if (!pageModel) {
        return undefined;
    }
    const sizeGuideDocument = getContentByRef(sizeGuideDocumentRef === null || sizeGuideDocumentRef === void 0 ? void 0 : sizeGuideDocumentRef.$ref, pageModel);
    if (!sizeGuideDocument) {
        return undefined;
    }
    return {
        findOutSizeCTA: sizeGuideDocument.findOutSizeCTA && {
            icon: sizeGuideDocument.findOutSizeCTA.icon,
            link: {
                url: sizeGuideDocument.findOutSizeCTA.link.url,
                label: sizeGuideDocument.findOutSizeCTA.link.label,
                alt: sizeGuideDocument.findOutSizeCTA.link.alt,
                openInNewWindow: sizeGuideDocument.findOutSizeCTA.link.openInNewWindow,
                style: sizeGuideDocument.findOutSizeCTA.link.style
            }
        },
        findOutSizeDescription: sizeGuideDocument.findOutSizeDescription,
        findOutSizeImage: sizeGuideDocument.findOutSizeImage,
        findOutSizeSubtitle: sizeGuideDocument.findOutSizeSubtitle,
        findOutSizeTitle: sizeGuideDocument.findOutSizeTitle,
        measureDescription: sizeGuideDocument.measureDescription,
        measureDescriptionImage: sizeGuideDocument.measureDescriptionImage,
        measureImage: sizeGuideDocument.measureImage,
        measureSteps: sizeGuideDocument.measureSteps,
        measureTitle: sizeGuideDocument.measureTitle,
        sizeGuideSizeCompound: sizeGuideDocument.sizeGuideSizeCompound,
        sizeTitle: sizeGuideDocument.sizeTitle
    };
}

export { getSizeGuideDocument };
//# sourceMappingURL=get-size-guide-document.js.map
